import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import './App.css';

function DetalleEmpleo() {
  const { id } = useParams();
  const [empleo, setEmpleo] = useState(null);
  const [coordenadas, setCoordenadas] = useState(null);

  useEffect(() => {
    fetch("https://opensheet.elk.sh/1eiyc-JP3WiO8NkO6Yf5FpoRpcysiTETtlLGmXLm50X8/Hoja1")
      .then(res => res.json())
      .then(data => {
        const encontrado = data.find(e => e.id === id);
        setEmpleo(encontrado);

        if (encontrado && encontrado.ciudad) {
          const query = `${encontrado.ciudad}, ${encontrado.provincia}, ${encontrado.país}`;
          fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json`)
            .then(res => res.json())
            .then(loc => {
              if (loc[0]) {
                setCoordenadas([parseFloat(loc[0].lat), parseFloat(loc[0].lon)]);
              }
            });
        }
      });
  }, [id]);

  if (!empleo) return <p style={{ padding: "2rem" }}>Cargando oferta...</p>;

  return (
    <>
      <div className="navbar">
        <div className="left">
          <Link to="/" className="logo-link">ArqueoJobs</Link>
        </div>
        <div className="right">
          <Link to="/">Envía Oferta</Link>
          <Link to="/">Info</Link>
          <Link to="/">Login</Link>
        </div>
      </div>

      <div className="detalle-wrapper wide">
        <div className="detalle-card">
          <Link to="/" className="volver">← Volver</Link>
          <h1>{empleo.puesto}</h1>
          <p><strong>Empresa:</strong> {empleo.empresa}</p>
          <p><strong>Ubicación:</strong> {empleo.ciudad}, {empleo.provincia}, {empleo.país}</p>
          <p><strong>Categoría:</strong> {empleo.categoría}</p>
          <p><strong>Tipo:</strong> {empleo.tipo_trabajo}</p>
          <p><strong>Salario:</strong> {empleo.salario}</p>
          <p><strong>Requisitos mínimos:</strong> {empleo.requisitos_mínimos}</p>
          <p><strong>Deseables:</strong> {empleo.requisitos_deseables}</p>
          <p><strong>Descripción:</strong></p>
          <p>{empleo.descripcion}</p>

          {coordenadas && (
            <div style={{ height: "300px", marginTop: "1rem", borderRadius: "8px", overflow: "hidden" }}>
              <MapContainer center={coordenadas} zoom={13} style={{ height: "100%", width: "100%" }}>
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={coordenadas}>
                  <Popup>{empleo.puesto} en {empleo.ciudad}</Popup>
                </Marker>
              </MapContainer>
            </div>
          )}

          <h3>📤 Enviar candidatura</h3>
          <form className="cv-form" onSubmit={(e) => e.preventDefault()}>
            <input type="text" placeholder="Tu nombre" required />
            <input type="email" placeholder="Tu email" required />
            <input type="file" />
            <button type="submit">Enviar CV</button>
          </form>
        </div>
      </div>
    </>
  );
}

export default DetalleEmpleo;
